import { Action } from '@ngrx/store';
import { ReferenceData } from './models/reference-data.model';
import { MinervaReferenceData } from './models/minerva-reference-data.model';
import { TypedReferenceData } from './models/typed-reference-data';
import { LoadReferenceDataItemPayload } from './load-reference-data-item-payload';
import { GenericReferenceData } from './models/generic-reference-data';

export enum ReferenceDataActionTypes {
  LoadReferenceDataItem = '[Reference Data Item] Load',
  LoadReferenceDataItemSuccess = '[Reference Data Item] Load Success',
  LoadReferenceDataItemFail = '[Reference Data Item] Load Fail',

  LoadReferenceData = '[Reference Data] Load',
  LoadReferenceDataSuccess = '[Reference Data] Load Success',
  LoadReferenceDataFail = '[Reference Data] Load Fail',
}

export class LoadReferenceDataItemAction<T extends GenericReferenceData> implements Action {
  readonly type: string = ReferenceDataActionTypes.LoadReferenceDataItem;

  constructor(public payload: LoadReferenceDataItemPayload<T>) {
  }
}

export class LoadReferenceDataItemSuccessAction<T extends GenericReferenceData> implements Action {
  readonly type: string = ReferenceDataActionTypes.LoadReferenceDataItemSuccess;
  constructor(public payload: TypedReferenceData<T>) {
  }
}

export class LoadReferenceDataItemFailAction implements Action {
  readonly type: string = ReferenceDataActionTypes.LoadReferenceDataItemFail;
  constructor(public payload: { type: string, err: Error }) {
  }
}

export class LoadReferenceDataAction<T extends GenericReferenceData> implements Action {
  readonly type: string = ReferenceDataActionTypes.LoadReferenceData;

  constructor(public payload: LoadReferenceDataItemPayload<T>[]) {
  }
}

export class LoadReferenceDataSuccessAction<T extends GenericReferenceData> implements Action {
  readonly type: string = ReferenceDataActionTypes.LoadReferenceDataSuccess;
  constructor(public payload: TypedReferenceData<T>[]) {
  }
}

export class LoadReferenceDataFailAction implements Action {
  readonly type: string = ReferenceDataActionTypes.LoadReferenceDataFail;
  constructor(public payload: { type: string, err: Error }) {
  }
}

export type ReferenceDataActions<T extends GenericReferenceData> =
  LoadReferenceDataItemAction<T>
  | LoadReferenceDataItemSuccessAction<T>
  | LoadReferenceDataItemFailAction
  | LoadReferenceDataAction<T>
  | LoadReferenceDataSuccessAction<T>
  | LoadReferenceDataFailAction;
